import {
  all, fork, take, takeLatest, call, put,
} from 'redux-saga/effects';

// actions
import { getPropertiesMarkers } from '../actions/mapActions';

// api methods
import Api from 'api/map';

function* ensureGetActivePropertiesCoordinates() {
  try {
    const { data } = yield call(Api.getActivePropertiesCoordinates);
    yield put({ type: getPropertiesMarkers.success, payload: data });
  } catch (err) {
    yield put({ type: getPropertiesMarkers.failure, err });
  }
}

function* watchGetActivePropertiesCoordinates() {
  yield takeLatest(getPropertiesMarkers.type, ensureGetActivePropertiesCoordinates);
  yield take(getPropertiesMarkers.success);
}

export default function* propertyViewSagas() {
  yield all([fork(watchGetActivePropertiesCoordinates)]);
}
